import React, { useState, useEffect } from "react";
import {
    Button,
    TextField,
    Paper,
    Box,
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@material-ui/core";
import HttpService from '../services/httpService';
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import { connect } from "react-redux";


const BankDetailsCollect = (props) => {
    const [formData, setFormData] = useState({
        email: "",
        accountHolder: "",
        bankName: "",
        branchName: "",
        accountNumber: "",
        confirmAccountNumber: "",
        ifscCode: "",
        uniqueLeadNumber: "",
        customerId: "",
        leadId: ""
    });

    const [errors, setErrors] = useState({});
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogMessage, setDialogMessage] = useState("");
    const [customerDetails, setCustomerDetails] = useState(null);

    // Extract url parameters in useEffect
    useEffect(() => {
        // Get URL parameters
        const queryParams = new URLSearchParams(window.location.search);
        const customerId = queryParams.get('customerId');
        const uniqueLeadNumber = queryParams.get('uniqueLeadNumber');
        const leadId = queryParams.get('leadId');

        // Update form data with these values
        setFormData(prevData => ({
            ...prevData,
            customerId,
            uniqueLeadNumber: uniqueLeadNumber || "",
            leadId: leadId || ""
        }));

        // Fetch customer details if customerId is available
        if (customerId) {
            fetchCustomerDetails(customerId);
        }
    }, []);

    // Function to fetch customer details
    const fetchCustomerDetails = async (id) => {
        try {
            props.setLoading(true);
            const response = await HttpService.getcustomerDetailsForReferral(id);
            props.setLoading(false);

            if (response.data && response.data.data) {
                const customerData = response.data.data;
                setCustomerDetails(customerData);

                // Update form with customer data
                setFormData(prevData => ({
                    ...prevData,
                    email: customerData.email || "",
                    accountHolder: customerData.name || "",
                }));

                // Show success message 
                props.setSnackInfo("Customer details loaded successfully", "success");
            } else {
                // Show error message 
                props.setSnackInfo("Failed to load customer details", "error");
            }
        } catch (error) {
            props.setLoading(false);
            console.error("Error fetching customer details:", error);
            // Show error message 
            props.setSnackInfo("Error loading customer details", "error");
        }
    };

    const validateForm = () => {
        let tempErrors = {};
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        const nameRegex = /^[A-Za-z\s]+$/;

        if (!emailRegex.test(formData.email)) {
            tempErrors.email = "Enter a valid email address";
        }

        if (!nameRegex.test(formData.accountHolder)) {
            tempErrors.accountHolder = "Name should contain only letters and spaces";
        }

        if (!nameRegex.test(formData.bankName)) {
            tempErrors.bankName = "Bank name should contain only letters and spaces";
        }
        if (!nameRegex.test(formData.branchName)) {
            tempErrors.branchName = "Branch name should contain only letters and spaces";
        }

        if (formData.accountNumber !== formData.confirmAccountNumber) {
            tempErrors.confirmAccountNumber = "Account numbers do not match";
        }

        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            try {
                props.setLoading(true);
                // prefilling
                const dataToSubmit = {
                    ...formData,
                    customerId: formData.customerId,
                    uniqueLeadNumber: formData.uniqueLeadNumber,
                    leadId: formData.leadId
                };

                const response = await HttpService.referalBankDetailsSave(dataToSubmit);
                props.setLoading(false);

                if (response.data.success) {
                    setDialogMessage("Thank you for submitting your bank details. We will get back to you once the process is complete.");
                    setOpenDialog(true);
                    handleReset();
                    // Show success message
                    props.setSnackInfo("Bank details submitted successfully", "success");
                } else {
                    //  non-success responses
                    props.setSnackInfo(response.data.message || "Failed to submit bank details", "error");
                }
            } catch (error) {
                props.setLoading(false);
                console.error("Error submitting bank details:", error);

                // Show specific error message based on the response
                if (error?.response && error?.response?.status === 403) {
                    props.setSnackInfo("Enter Account and IFSC details correctly. Starting of IFSC should be in CAPITAL and Account number should be 9 digit", "error");
                } else if (error?.response && error?.response?.status === 400) {
                    // Handle validation errors
                    props.setSnackInfo("Bank details already submitted", "error");
                } else {
                    props.setSnackInfo("Failed to connect to server. Please try again later.", "error");
                }
            }
        }
    };
    const handleReset = () => {
        // Keeping the customerId and uniqueLeadNumber when resetting
        const { customerId, uniqueLeadNumber, leadId } = formData;
        setFormData({
            email: customerDetails?.email || "",
            accountHolder: customerDetails?.name || "",
            bankName: "",
            branchName: '',
            accountNumber: "",
            confirmAccountNumber: "",
            ifscCode: "",
            uniqueLeadNumber: uniqueLeadNumber || "",
            customerId,
            leadId: leadId || ""
        });
        setErrors({});
    };

    return (
        <Paper style={{ padding: "20px", maxWidth: "500px", margin: "auto", marginTop: "20px" }}>
            <Typography variant="h5" style={{ marginBottom: "10px" }}>Referral Bank Details Collection</Typography>
            <form onSubmit={handleSubmit}>
                <TextField
                    fullWidth
                    label="Email"
                    name="email"
                    value={formData.email}
                    //  making uneditable for customer
                    InputProps={{
                        readOnly: true,
                    }}
                    required
                    margin="dense"
                    error={!!errors.email}
                    helperText={errors.email}
                />
                <TextField
                    fullWidth
                    label="Name of the Account Holder"
                    name="accountHolder"
                    value={formData.accountHolder}
                    onChange={handleChange}
                    required
                    margin="dense"
                    error={!!errors.accountHolder}
                    helperText={errors.accountHolder}
                />
                <TextField
                    fullWidth
                    label="Name of the Bank"
                    name="bankName"
                    value={formData.bankName}
                    onChange={handleChange}
                    required
                    margin="dense"
                    error={!!errors.bankName}
                    helperText={errors.bankName}
                />
                <TextField
                    fullWidth
                    label="Name of Branch"
                    name="branchName"
                    value={formData.branchName}
                    onChange={handleChange}
                    required
                    margin="dense"
                    error={!!errors.branchName}
                    helperText={errors.branchName}
                />
                <TextField
                    fullWidth
                    label="Account Number"
                    name="accountNumber"
                    type="password"
                    value={formData.accountNumber}
                    onChange={handleChange}
                    required
                    margin="dense"
                />
                <TextField
                    fullWidth
                    label="Confirm Account Number"
                    name="confirmAccountNumber"
                    type="number"
                    value={formData.confirmAccountNumber}
                    onChange={handleChange}
                    required
                    margin="dense"
                    error={!!errors.confirmAccountNumber}
                    helperText={errors.confirmAccountNumber}
                />
                <TextField
                    fullWidth
                    label="IFSC Code"
                    name="ifscCode"
                    value={formData.ifscCode}
                    onChange={handleChange}
                    required
                    margin="dense"
                />
                <TextField
                    fullWidth
                    label="Your unique Lead Number or Project No"
                    name="uniqueLeadNumber"
                    value={formData.uniqueLeadNumber}
                    //  making uneditable for customer
                    InputProps={{
                        readOnly: true,
                    }}
                    required
                    margin="dense"
                />
                <Box mt={2} display="flex" justifyContent="space-between">
                    <Button type="submit" variant="contained" color="primary">
                        Submit
                    </Button>
                    <Button type="button" variant="contained" color="secondary" onClick={handleReset}>
                        Reset
                    </Button>
                </Box>
            </form>
            {/* Success Dialog */}
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                <DialogTitle>Submission Successful</DialogTitle>
                <DialogContent>
                    <DialogContentText>{dialogMessage}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)} color="primary" autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </Paper>
    );
};

export default connect(null, { setLoading, setSnackInfo })(BankDetailsCollect);